import axios from "axios";

const urls = process.env.REACT_APP_BASE_URL;

//포인트 - 포인트 교환 페이지 리스트
export const requestPointAffiliateList = (params) =>
  axios
    .post(`${urls}/mu/point/affiliate/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//포인트 - 포인트 교환 - 연동하기
export const requestPointAffiliateLink = (params) =>
  axios
    .post(`${urls}/mu/point/affiliate/link`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//포인트 - 포인트교환 페이지 진입
export const requestPointLookUp = (params) =>
  axios
    .post(`${urls}/mu/point/exchange/lookup`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//포인트 - 포인트교환 실행
export const requestPointExChange = (params) =>
  axios
    .post(`${urls}/mu/point/exchange/action`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
